export default __webpack_public_path__ + "341297593fefc2ca73ad7a3debd5a088.png";